export default "__VITE_ASSET__C50ePkOS__"